"use client"

import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  CircleXIcon,
  CircleAlertIcon,
} from "lucide-react"
import { useTheme } from "@/contexts/ThemeContext"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4 mr-2 text-[var(--normal-text)]" />,
        info: <InfoIcon className="size-4 mr-2 text-[var(--normal-text)]" />,
        warning: <CircleAlertIcon className="size-4 mr-2 text-[var(--normal-text)]" />,
        error: <CircleXIcon className="size-4 mr-2 text-[var(--normal-text)]" />,
        loading: <Loader2Icon className="animate-spin size-4 mr-2 text-[var(--normal-text)]" />,
      }}
      toastOptions={{
        classNames: {
          toast: "group toast group-[.toaster]:bg-white group-[.toaster]:dark:bg-zinc-900 group-[.toaster]:border group-[.toaster]:border-solid",
          title: "group-[.toast]:font-medium group-[.toaster]:text-[var(--normal-text)]",
          description: "group-[.toast]:opacity-90",
          actionButton: "group-[.toast]:bg-zinc-900 group-[.toast]:dark:bg-zinc-50 group-[.toast]:text-white group-[.toast]:dark:text-zinc-900",
          cancelButton: "group-[.toast]:bg-zinc-100 group-[.toast]:dark:bg-zinc-800 group-[.toast]:text-zinc-500 group-[.toast]:dark:text-zinc-400",
          success: "group-[.toaster]:border-emerald-200 group-[.toaster]:dark:border-emerald-800 group-[.toaster]:[--normal-text:theme(colors.emerald.700)] group-[.toaster]:dark:[--normal-text:theme(colors.emerald.300)]",
          error: "group-[.toaster]:border-red-200 group-[.toaster]:dark:border-red-800 group-[.toaster]:[--normal-text:theme(colors.red.700)] group-[.toaster]:dark:[--normal-text:theme(colors.red.300)]",
          warning: "group-[.toaster]:border-amber-200 group-[.toaster]:dark:border-amber-800 group-[.toaster]:[--normal-text:theme(colors.amber.700)] group-[.toaster]:dark:[--normal-text:theme(colors.amber.300)]",
          info: "group-[.toaster]:border-blue-200 group-[.toaster]:dark:border-blue-800 group-[.toaster]:[--normal-text:theme(colors.blue.700)] group-[.toaster]:dark:[--normal-text:theme(colors.blue.300)]",
          loading: "group-[.toaster]:border-zinc-200 group-[.toaster]:dark:border-zinc-800 group-[.toaster]:[--normal-text:theme(colors.zinc.700)] group-[.toaster]:dark:[--normal-text:theme(colors.zinc.300)]",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
